import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useSelfScheduleContext } from "@/contexts/self-schedule-provider";
import { selfScheduleQueryOptions } from "@/api/check-in/self-schedule/self-schedule-query";

/** Each provider's soonest opening for the selected visit, keyed by provider ID. */
export const useProviderNextAvailability = providerIds => {
  const $ = _c(18);
  const {
    requestedAssignments,
    selectedLocation,
    selectedAddons,
    bookingEvent
  } = useSelfScheduleContext();
  let locationId;
  let serviceIds;
  let t0;
  let t1;
  if ($[0] !== bookingEvent?.id || $[1] !== providerIds || $[2] !== requestedAssignments || $[3] !== selectedAddons || $[4] !== selectedLocation?.id) {
    serviceIds = requestedAssignments.map(_temp);
    locationId = selectedLocation?.id ?? "";
    t1 = useQuery;
    t0 = selfScheduleQueryOptions.providerNextAvailability({
      serviceIds,
      providerIds,
      locationId,
      addonSelections: selectedAddons,
      bookingEventId: bookingEvent?.id ?? null
    });
    $[0] = bookingEvent?.id;
    $[1] = providerIds;
    $[2] = requestedAssignments;
    $[3] = selectedAddons;
    $[4] = selectedLocation?.id;
    $[5] = locationId;
    $[6] = serviceIds;
    $[7] = t0;
    $[8] = t1;
  } else {
    locationId = $[5];
    serviceIds = $[6];
    t0 = $[7];
    t1 = $[8];
  }
  const t2 = !!locationId && serviceIds.length > 0 && providerIds.length > 0;
  let t3;
  if ($[9] !== t0 || $[10] !== t2) {
    t3 = {
      ...t0,
      enabled: t2,
      staleTime: 300000,
      refetchOnWindowFocus: false
    };
    $[9] = t0;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const {
    data,
    isLoading,
    isError
  } = t1(t3);
  let t4;
  if ($[12] !== data) {
    t4 = new Map(data?.map(_temp2));
    $[12] = data;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const nextAvailableByProviderId = t4;
  const t5 = !!data && !isError;
  let t6;
  if ($[14] !== isLoading || $[15] !== nextAvailableByProviderId || $[16] !== t5) {
    t6 = {
      nextAvailableByProviderId,
      isLoading,
      isLoaded: t5
    };
    $[14] = isLoading;
    $[15] = nextAvailableByProviderId;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
function _temp(t0) {
  const {
    serviceId
  } = t0;
  return serviceId;
}
function _temp2(t0) {
  const {
    providerId,
    start
  } = t0;
  return [providerId, start];
}